module.exports = __webpack_public_path__ + "img/speaker-DachiImedadze.3162d085.png";